import React from "react";
import { Box, DialogTitle, IconButton, Typography } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

type ObjetivoHeader = {
  codigo: string;
  objetivo: string;
};

interface Props {
  objetivo: ObjetivoHeader;
  onClose: () => void;
}

const ObjectiveSelectHeader: React.FC<Props> = ({ objetivo, onClose }) => {
  return (
    <DialogTitle sx={{ fontFamily: "Montserrat" }}>
      <Box display="flex" alignItems="flex-start" justifyContent="space-between">
        <Box>
          <Typography
            sx={{
              fontFamily: "Montserrat",
              fontWeight: 700,
              color: "#234C61",
              fontSize: "1rem",
            }}
          >
            {objetivo.codigo}
          </Typography>

          <Typography
            sx={{
              fontFamily: "Montserrat",
              fontWeight: 800,
              color: "#234C61",
              fontSize: "1.25rem",
              mt: 0.3,
            }}
          >
            Objetivo de Aprendizaje
          </Typography>
        </Box>

        <IconButton onClick={onClose}>
          <CloseIcon />
        </IconButton>
      </Box>

      <Typography
        sx={{
          fontFamily: "Montserrat",
          color: "rgba(0,0,0,0.60)",
          fontSize: "0.75rem",
          fontWeight: 400,
          mt: 1.2,
          lineHeight: 1.35,
        }}
      >
        {objetivo.objetivo}
      </Typography>

      <Typography
        sx={{
          fontFamily: "Montserrat",
          color: "rgba(0,0,0,0.60)",
          fontSize: "0.75rem",
          fontWeight: 700,
          mt: 1.6,
        }}
      >
        Selecciona a continuación:
      </Typography>
    </DialogTitle>
  );
};

export default ObjectiveSelectHeader;
